import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_CHAT_RULES: IntlKeyValuePair = {
    key: "chatRules",
    defaultValue: "Unibuddy Chat Rules",
    intlValue: "Unibuddy Chat Rules",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_SUB_TITLE: IntlKeyValuePair = {
    key: "subTitle",
    defaultValue: "Hello! Here are some",
    intlValue: "Hello! Here are some",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_START_A_CHAT: IntlKeyValuePair = {
    key: "startAChat",
    defaultValue: "Start a chat, not a fire!",
    intlValue: "Start a chat, not a fire!",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_THINGS_WE_LIKE: IntlKeyValuePair = {
    key: "thingsWeLike",
    defaultValue: "Things we like:",
    intlValue: "Things we like:",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_SHARING_EXPERIENCE: IntlKeyValuePair = {
    key: "sharingExperience",
    defaultValue: "Sharing our uni experiences",
    intlValue: "Sharing our uni experiences",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_TALKING_ABOUT_COURSE: IntlKeyValuePair = {
    key: "talkingAboutCourse",
    defaultValue: "Talking about our course/program",
    intlValue: "Talking about our course/program",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_GIVING_TIPS: IntlKeyValuePair = {
    key: "givingTips",
    defaultValue: "Giving tips and advice about student life",
    intlValue: "Giving tips and advice about student life",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_THINGS_WE_DONT_LIKE: IntlKeyValuePair = {
    key: "thingsWeDontLike",
    defaultValue: "Things that we don't like:",
    intlValue: "Things that we don't like:",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_OFFENSIVE_MESSAGES: IntlKeyValuePair = {
    key: "offensiveMessages",
    defaultValue: "Rude or offensive messages",
    intlValue: "Rude or offensive messages",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_SHARING_SOCIAL_MEDIA: IntlKeyValuePair = {
    key: "sharingSocialMedia",
    defaultValue: "Sharing phone numbers/social media",
    intlValue: "Sharing phone numbers/social media",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_BAD_VIBES: IntlKeyValuePair = {
    key: "badVibes",
    defaultValue: "General bad vibes",
    intlValue: "General bad vibes",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_ROMANTIC_COMMENTS: IntlKeyValuePair = {
    key: "romanticComments",
    defaultValue: "Romantic comments or questions - Unibuddy is not a dating site",
    intlValue: "Romantic comments or questions - Unibuddy is not a dating site",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_CONTACT_SUPPORT: IntlKeyValuePair = {
    key: "contactSupport",
    defaultValue: "If you have any issues/comments, we'd love to hear them: ",
    intlValue: "If you have any issues/comments, we'd love to hear them: ",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_HAPPY_CHATTING: IntlKeyValuePair = {
    key: "happyChatting",
    defaultValue: "Happy Chatting!",
    intlValue: "Happy Chatting!",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};

export const INTL_GOT_IT: IntlKeyValuePair = {
    key: "gotIt",
    defaultValue: "Got it !",
    intlValue: "Got it !",
    namespace: IntlNamespaces.CODE_OF_CONDUCT,
};
